import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { ReactSVG } from 'react-svg';

import { resetAuthentication } from '../../../authentication/actions';
import { trans } from '../../../localization';
import SettingModal from '../../../pages/Setting/SettingModal';
import { isEmpty, isEmptyObject } from '../../../utils/utils';
import { toggleSidebarMenu } from '../../actions';
import NotificationBellWrapper from './components/NotificationBellWrapper';
import UserDropdown from './components/UserDropdown';

import avatarDefaultIcon from '../../../assets/common/images/icon/avatar-default.png';
import BarsIcon from '../../../assets/common/static/icons/bars.png';
import PhoneSvgIcon from '../../../assets/common/svg/phone.svg';

const ToggleMenuButton = ({ onClick }) => (
  <div className="icon-sidebar-menu" onClick={onClick}>
    <img src={BarsIcon} alt="bars icon" className="bars-icon" />
  </div>
);

const DropDownUser = ({
  avatar,
  fullName,
  onLogoutClick,
  isDropdownUserOpen,
  toggleUserOpen,
  openSettingModalConnect,
}) => {
  const isDefaultAvatar = /user-default-(male|female).png$/i.test(avatar);
  return (
    <div className="user-profile">
      <div className="dropdown-toggle" onClick={() => toggleUserOpen()}>
        <img
          src={
            !isDefaultAvatar ? avatar || avatarDefaultIcon : avatarDefaultIcon
          }
          width="40"
          height="40"
          style={{ borderRadius: '50%' }}
          alt=" "
          className="mr-2"
        />
        {fullName}
      </div>
      {isDropdownUserOpen && (
        <UserDropdown
          onLogoutClick={onLogoutClick}
          toggleUserOpen={toggleUserOpen}
          openSettingModal={openSettingModalConnect}
        />
      )}
    </div>
  );
};

const HeaderRightInfo = ({
  isLogin,
  avatar,
  fullName,
  onLogoutClick,
  isDropdownUserOpen,
  toggleUserOpen,
  openSettingModalConnect,
}) => (
  <div className="col-auto header-right-wrap">
    {isLogin && (
      <React.Fragment>
        <DropDownUser
          avatar={avatar}
          fullName={fullName}
          onLogoutClick={onLogoutClick}
          isDropdownUserOpen={isDropdownUserOpen}
          toggleUserOpen={toggleUserOpen}
          openSettingModalConnect={openSettingModalConnect}
        />
        <NotificationBellWrapper />
      </React.Fragment>
    )}
    <span>
      <ReactSVG
        src={PhoneSvgIcon}
        wrapper="span"
        beforeInjection={svg => {
          svg.setAttribute(
            'style',
            `width: 24px;height:24px;margin:0 8px 0 0;color:rgba(0,0,0,0.65);`,
          );
        }}
      />
      {trans('mod_email_support')}:
      <a
        href="mailto:hotroquan@support.shopeefood.vn"
        style={{
          fontWeight: 'bold',
          color: 'rgba(0,0,0,.87)',
          marginLeft: '4px',
        }}
      >
        hotroquan@support.shopeefood.vn
      </a>
    </span>
  </div>
);

class Header extends Component {
  state = {
    isDropdownUserOpen: false,
    isOpenDialogSetting: false,
  };

  toggleSidebarMenu = () => {
    const { toggleSidebarMenuConnect, isSidebarCollapse } = this.props;
    toggleSidebarMenuConnect(!isSidebarCollapse);
  };

  toggleUserOpen = isOpen => {
    this.setState(prevState => ({
      isDropdownUserOpen: isEmpty(isOpen)
        ? !prevState.isDropdownUserOpen
        : isOpen,
    }));
  };

  handleLogout = () => {
    const { resetAuthenticationConnect } = this.props;
    resetAuthenticationConnect();
    this.toggleUserOpen(false);
  };

  handleOpenSettingModal = isOpenDialogSetting => {
    this.setState({ isOpenDialogSetting });
  };

  render() {
    const { authenticated, user, metadata, history } = this.props;
    const { isDropdownUserOpen, isOpenDialogSetting } = this.state;
    const { name: fullName, photos } = user;
    const avatar =
      !isEmptyObject(photos) && !isEmptyObject(photos[0])
        ? photos[0].value
        : '';
    return (
      <header className="main-header">
        <div className="container-fluid row row justify-content-between align-items-center">
          <div className="col row justify-content-between align-items-center no-gutters">
            <ToggleMenuButton onClick={this.toggleSidebarMenu} />
            <HeaderRightInfo
              isLogin={authenticated}
              avatar={avatar}
              fullName={fullName}
              onLogoutClick={this.handleLogout}
              isDropdownUserOpen={isDropdownUserOpen}
              toggleUserOpen={this.toggleUserOpen}
              openSettingModalConnect={this.handleOpenSettingModal}
              metadata={metadata}
            />
          </div>
          <SettingModal
            isOpenDialog={isOpenDialogSetting}
            openSettingModal={this.handleOpenSettingModal}
            history={history}
          />
        </div>
      </header>
    );
  }
}

const mapStateToProps = state => ({
  authenticated: state.auth.authenticated,
  user: state.auth.user,
  isSidebarCollapse: state.app.isSidebarCollapse,
  metadata: state.app.metadata,
});

const mapDispatchToProps = dispatch => ({
  resetAuthenticationConnect: () => {
    dispatch(resetAuthentication());
  },
  toggleSidebarMenuConnect: isShow => {
    dispatch(toggleSidebarMenu(isShow));
  },
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Header));



// WEBPACK FOOTER //
// ./foody/src/layout/components/Header/Header.jsx